module.exports = __webpack_public_path__ + "static/media/DuplicateSans-BoldItalic.367197bf.woff";